import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_COSTUME_FEATURE_NOTE } from "../graphql";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class UpdateNoteService {
  public async updateNote(args: { id: string; note: string }) {
    try {
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      const res = await client.mutate({
        mutation: UPDATE_COSTUME_FEATURE_NOTE,
        variables: {
          updateCostumeFeatureNoteId: args.id,
          note: args.note,
        },
      });

      return {
        success: true,
        data: res?.data?.updateCostumeFeatureNote,
      };
    } catch (err: any) {
      console.error("Error in updateCostumeFeatureNote:", err);
      const displayError =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);

      if (displayError?.extensions?.display_message) {
        throw new Error(displayError.extensions.display_message);
      }
      throw err;
    }
  }
}
